import { Link } from "react-router-dom";
import { NAV, CONTACT } from "../data/content";

export default function Footer() {
  return (
    <footer className="bg-night text-ivory overflow-x-hidden" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20 pt-24 md:pt-32 pb-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          <div className="md:col-span-6">
            <p className="max-w-md font-sans text-sm text-ivory/60 leading-[1.7]">
              Performance marketing built for fashion. We scale D2C fashion, beauty and
              luxury brands from the beginning into something that lasts.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="font-sans text-xs uppercase tracking-[0.25em] text-gold mb-6">Menu</p>
            <ul className="space-y-3">
              {NAV.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    data-testid={`footer-nav-${item.label.toLowerCase()}`}
                    className="font-sans text-sm text-ivory/70 hover:text-gold transition-colors duration-300"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="font-sans text-xs uppercase tracking-[0.25em] text-gold mb-6">Contact</p>
            <ul className="space-y-3 font-sans text-sm text-ivory/70">
              <li>
                <a href={`mailto:${CONTACT.email}`} className="hover:text-gold transition-colors duration-300 break-all" data-testid="footer-email">
                  {CONTACT.email}
                </a>
              </li>
              <li>
                <a href={`https://wa.me/919953080505`} target="_blank" rel="noreferrer" className="hover:text-gold transition-colors duration-300" data-testid="footer-whatsapp">
                  WhatsApp {CONTACT.whatsapp}
                </a>
              </li>
              <li className="pt-3 text-ivory/50 tracking-[0.1em]">{CONTACT.cities.join(" · ")}</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 md:mt-24">
          <h2 className="font-serif font-light leading-[1.1] tracking-[0.02em] text-ivory text-[12vw] md:text-[10vw] lg:text-[8.5vw] whitespace-nowrap pb-2">
            CONNECT.CO
          </h2>
        </div>

        <div className="mt-10 pt-8 border-t border-ivory/15 flex flex-col md:flex-row justify-between gap-4">
          <p className="font-sans text-xs text-ivory/40 tracking-wide">
            © {new Date().getFullYear()} Connect.Co. Fashion-native performance marketing.
          </p>
          <p className="font-sans text-xs text-ivory/40 tracking-[0.2em] uppercase">
            Mumbai · London · New York · Dubai
          </p>
        </div>
      </div>
    </footer>
  );
}
